import script from "./StudentDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDashboard.vue?vue&type=script&setup=true&lang=js"

import "./StudentDashboard.vue?vue&type=style&index=0&id=39120f49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39120f49"]])

export default __exports__